<template>
	<main id="liste">
		<HeaderTab :title="$t('monte.personnalisation_model')" />
		
		<div id="content">
			<div class="container-fluid">
				<div class="row">
					<div class="col-12">
						<EditModel :modelable_id="modelableId" :modelable_type="modelableType" :model_id="modelId" />
					</div>
				</div>
			</div>
		</div>
	</main>
</template>

<script type="text/javascript">

	export default {
		name: "EditModelContract",
		computed: {
			modelableId () {
				return this.$route.params.modelable_id
			},
			modelableType () {
				return this.$route.params.modelable_type
			},
			modelId () {
				return this.$route.params.model_id
			}
		},
		components: {
			HeaderTab : () => import('@/components/HeaderTab'),
			EditModel : () => import('@/components/Model/Edit')
		}
	}

</script>